import type { Feature } from '../types';
import { Region, FeatureName, ApplicationChannel } from '../config';
import { Adapters } from '../adapters';

const installment2c2p: Feature = {
  featureName: FeatureName.INSTALMENT_TCTP,
  description: 'Installment configuration',
  enabledRegions: [Region.SG],
  enabledAppChannels: [ApplicationChannel.WEB],
  status: true,
  payload: {
    banks: [
      {
        name: 'DBS',
        icon: 'https://res.cloudinary.com/crusader/image/upload/f_auto,q_auto,c_fit/v1691655629/D05.SI_e40gvq.png',
      },
      {
        name: 'OCBC',
        icon: 'https://res.cloudinary.com/crusader/image/upload/f_auto,q_auto,c_fit/v1691655629/O39.SI_lvfom6.png',
      },
      {
        name: 'UOB',
        icon: 'https://res.cloudinary.com/crusader/image/upload/f_auto,q_auto,c_fit/v1691655629/U11.SI_xofbb9.png',
      },
      {
        name: 'AMEX',
        icon: 'https://res.cloudinary.com/crusader/image/upload/f_auto,q_auto,c_fit/v1691655629/AXP_nqzj17.png',
      },
    ],
    url: Adapters.instalmentUrl,
    encrypt: Adapters.instalmentEncrypt,
  },
};

export default installment2c2p;
